import { useEffect } from "react";
import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { HowItWorks } from "../components/HowItWorks";
import { Tours } from "../components/Tours";
import { Features } from "../components/Features";
import { Screenshots } from "../components/Screenshots";
import { Languages } from "../components/Languages";
import { Contact } from "../components/Contact";
import { Footer } from "../components/Footer";
import { useSiteLang } from "../lib/siteLang";
import { applySeo } from "../lib/seo";

const META = {
  it: {
    title: "GozzoGuide — La tua guida personale in tasca",
    description: "GozzoGuide: la tua guida personale in tasca. Audioguide in 11 lingue per il tour in barca e a terra a Capri e sulla Costiera Amalfitana. Gratuita su iPhone e Android.",
  },
  en: {
    title: "GozzoGuide — Your personal guide in your pocket",
    description: "GozzoGuide: your personal guide in your pocket. Audio guides in 11 languages for the boat tour and the land tour in Capri and on the Amalfi Coast. Free on iPhone and Android.",
  },
};

export default function LandingPage() {
  const { lang, t } = useSiteLang();

  useEffect(() => applySeo({ path: "/" }), []);

  // The title and the description follow the language chosen on the page
  useEffect(() => {
    document.title = META[lang].title;
    document.querySelector('meta[name="description"]')?.setAttribute("content", META[lang].description);
  }, [lang]);

  return (
    <div className="min-h-screen bg-[#09101F]" data-testid="landing-page">
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[100] focus:rounded-full focus:bg-white focus:px-4 focus:py-2 focus:text-[#09101F] focus:font-semibold"
      >
        {t.skip}
      </a>
      <Navbar />
      <main id="main">
        <Hero />
        <HowItWorks />
        <Tours />
        <Features />
        <Screenshots />
        <Languages />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
